const TrusteeCommission = () => {
  return (
    <div className="flex flex-col justify-center items-center p-4">
      <h1 className="text-4xl font-bold text-yellow-500">Trustee Commission</h1>
      <p className="text-lg text-gray-400">Trustee Commission details coming soon...</p>
    </div>
  );
};

export default TrusteeCommission;
